import { render, staticRenderFns } from "./form-btn.vue?vue&type=template&id=3f0f0ff5&scoped=true&"
import script from "./form-btn.vue?vue&type=script&lang=ts&"
export * from "./form-btn.vue?vue&type=script&lang=ts&"
import style0 from "./form-btn.vue?vue&type=style&index=0&id=3f0f0ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f0ff5",
  null
  
)

export default component.exports